"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderLineType = void 0;
var OrderLineType;
(function (OrderLineType) {
    OrderLineType["BEND"] = "bend";
    OrderLineType["WELDING"] = "welding";
})(OrderLineType = exports.OrderLineType || (exports.OrderLineType = {}));
//# sourceMappingURL=types.js.map